// extracted by mini-css-extract-plugin
module.exports = {"reviews-and-rating-wrapper":"ReviewsAndRating_reviews-and-rating-wrapper__gcaBG"};